import { Grid, TextField, Typography } from "@material-ui/core"
import React, { useState } from "react"

export default function ResetDeviceOTAMessageSection(props) {
  const { setMessageData, setValidated } = props
  const [acknowledge, setAcknowledge] = useState("")

  const reviewComponent = (value) => {
    setAcknowledge(value)
    if (value === "I Understand") {
      setValidated(true)
      setMessageData({
        command: "reset_device",
      })
    } else {
      setValidated(false)
      setMessageData(null)
    }
  }

  return (
    <>
      <Grid item xs={12}>
        <Typography>
          Resetting a device will delete all images in the backlog and remove the on-device
          database. Please write "I Understand" to acknowledge this.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          rows={4}
          inputProps={{
            maxLength: 100,
          }}
          margin="dense"
          label='Write "I Understand"'
          name="Acknowledgement"
          value={acknowledge}
          onChange={(event) => reviewComponent(event.currentTarget.value)}
        />
      </Grid>
    </>
  )
}
